import { Passenger, PassengerError } from 'interfaces/booking';
import { validateInvoicePassengerInput } from './validation';

export const validateAllInvoiceInputs = (invoice: Passenger) => {
  // Loops through all the invoice inputs and validates them
  let error = {} as PassengerError;
  const notUsedInputs = ['typeCode', 'documentId', 'documentExpirationDay', 'documentExpirationMonth', 'documentExpirationYear', 'documentCountry', 'documentType', 'ancillary'];

  (Object.keys(invoice) as (keyof Passenger)[]).map(key => {
    if(!notUsedInputs.includes(key)) {
      let tmpError: PassengerError = validateInvoicePassengerInput(
        invoice,
        key,
        '',
      );
  
      // If no validation error was found not appending it to the object
      if (tmpError[key] !== '') {
        error = { ...error, ...tmpError };
      }
    }
  });

  return error;
};
